import React, { Component } from 'react'
import { ContainerStatus, ImageCard } from './muvicard.style'
import Limit from './componentes/Limit/limit.component'
import Bill from './componentes/Bill/bill.component'
import { SummaryBox } from '../../styles.style'
import Modal from '../../../../components/modal/modal.component'
import Summary from '../summary/summary.component'
import { CardBoxButton } from './componentes/CardBoxButton/card-box-button.component'
import { invoiceStatus } from '../../../private/employee/reports/invoices/invoices.constants'
import { MuvicardService } from '../../../../services/muvicard.service'
import ModalConfirmation from '../../../../components/modal/modal-confirmation.component'
import { Formik } from 'formik'
import { MoneyInput } from '../../../../components/form-components/inputs.component'
import fileSaver from '../../../../helpers/download.helper'
import { dateHelper, maskHelper } from '../../../../helpers'
import Yup from '../../../../helpers/custom-yup'
class Muvicard extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isOpen: false,
			isComplementOpen: false,
			complementValue: ''
		}
	}


	handlePayInvoice = () => {
		const { monthDescription, bankSlipKey, showLoading, hideLoading } = this.props
		showLoading()
		MuvicardService.DownloadInvoiceBankslip(bankSlipKey, monthDescription);
		setTimeout(() => { hideLoading() }, 2000);
	}

	setComplementValue(e, setFieldValue) {
		const maxValue = 10000;
		var newValue = parseFloat(e.replace(",", "."))
		this.setState({ complementValue: e })
		if (newValue > maxValue) {
			this.setState({ complementValue: maxValue })
			setFieldValue('complementValue', maskHelper.applyBrazilianCurrency(maxValue))
		}
	}

	onResult = (confirmed) => {
		const { showLoading, hideLoading } = this.props
		const complementValue = parseFloat(this.state.complementValue.replace(",", "."))
		this.setState({ isComplementOpen: false })
		if (confirmed && complementValue > 0) {
			showLoading()
			MuvicardService.GenerateParcialInvoice(complementValue)
				.then((response) => {
					const { data } = response
					if (data) {
						fileSaver(
							data,
							`Fatura parcial ${dateHelper.formatDefault(new Date())}.pdf`
						)
					}
				})
				.catch(() => [])
				.finally(() => hideLoading())
		}
	}

	render() {
		const schema = Yup.object().shape({
			complementValue: Yup.number()
				.required('Informe o valor do boleto')
				.nullable()
		})

		const {
			isPJ,
			name,
			status,
			percent,
			invoices,
			limitValue,
			cardStatus,
			closingDate,
			bankSlipKey,
			partialValue,
			invoiceExists,
			expirationDate,
			monthDescription,
			originalLimitValue,
			onChangeCompetence,
			selectedCompetence
		} = this.props

		const shouldRenderPayBankslipButton =
			(status === invoiceStatus.CLOSED || status === invoiceStatus.DELAYED) && bankSlipKey

		const shouldRenderCardInvoiceComplement = status && invoiceExists && status === invoiceStatus.PENDING && isPJ && partialValue > 0

		return (
			<ContainerStatus>
				<ImageCard>
					<p>{name}</p>
				</ImageCard>

				<Limit
					percent={percent}
					cardStatus={cardStatus}
					limitValue={limitValue}
					closingDate={closingDate}
					invoiceExists={invoiceExists}
					originalLimitValue={originalLimitValue}
				/>
				<Bill
					status={status}
					closingDate={closingDate}
					partialValue={partialValue}
					invoiceExists={invoiceExists}
					expirationDate={expirationDate}
					selectedCompetence={selectedCompetence}
					onChangeCompetence={onChangeCompetence}
				/>
				{shouldRenderPayBankslipButton && (
					<CardBoxButton
						allDevices
						title="Pagar Boleto"
						text="Pagar"
						handleClick={this.handlePayInvoice}
					/>
				)}
				<CardBoxButton
					desktop
					title="Ver resumo de todas as faturas"
					text="Ver resumo de todas as faturas"
					monthDescription={monthDescription}
					handleClick={() => this.setState({ isOpen: true })}
				/>

				{shouldRenderCardInvoiceComplement && (<CardBoxButton
					allDevices
					title="Gerar fatura parcial"
					text="Gerar fatura parcial"
					handleClick={() => this.setState({ isComplementOpen: true })}
				/>
				)}

				<Modal
					noPadding
					animation="fadeIn"
					isOpen={this.state.isOpen}
					onClose={() => this.setState({ isOpen: false })}>
					<SummaryBox>
						<Summary
							invoices={invoices}
							partialValue={partialValue}
							monthDescription={monthDescription}
						/>
						<footer className="footer-modal">
							<button
								className="lk-resume"
								onClick={() => this.setState({ isOpen: false })}>
								Voltar para meu cartão
							</button>
						</footer>
					</SummaryBox>
				</Modal>

				<ModalConfirmation
					buttonYesText="Gerar boleto"
					buttonNoText="Cancelar"
					isOpen={this.state.isComplementOpen}
					onResult={this.onResult}
				>
					<Formik
						ref="form"
						initialValues={{ complementValue: 0 }}
						validationSchema={schema}
						render={props => {
							const { setFieldValue } = props
							return (
								<form noValidate onSubmit={props.handleSubmit} autoComplete="off">
									<MoneyInput
										label={'Informe o valor desejado de pagamento avulso, parcial ou antecipado.*'}
										id={'complementValue'}
										name='complementValue'
										onComplete={e => this.setComplementValue(e, setFieldValue)}
										onChange={e => this.setComplementValue(e, setFieldValue)}
										{...props}
									/>
									<span className="partial-payment-info">Assim que identificado o pagamento, o valor estará disponível na sua fatura em aberto.</span>
								</form>
							)
						}}
					/>
				</ModalConfirmation>
			</ContainerStatus>
		)
	}
}

export default Muvicard
